<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <!-- <layout-header2></layout-header2> -->
          <layout-header></layout-header>
          <breadcrumb54></breadcrumb54>
          <!-- Page Content -->
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                  <sidebar2></sidebar2>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                  <loader></loader>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9 doctor-profile" v-else>
                  <!-- <h3 class="mb-5 mt-2">Profile of {{ doctor_profile.first_name }} {{ doctor_profile.last_name }} </h3> -->
                  <nav class="navbar navbar-expand-lg header-nav ml-md-4">
                    <div class="main-menu-wrapper patient-encounter" style="justify-content: flex-start;">
                      <div class="menu-header" style="width:auto; height:43px;">
                        <a id="menu_close" class="menu-close" href="javascript:void(0);">
                          <i class="fas fa-times"></i>
                        </a>
                      </div>
                      <ul class="main-nav">
                        <li>
                          <a href="javascript:void(0);" :class="active == 'Details' ? 'active_menu' : ''"
                            @click="active_menu('Details'); menu_close()">About
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0);" :class="active == 'C-Details' ? 'active_menu' : ''"
                            @click="active_menu('C-Details'); menu_close()">Contact
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0);" :class="active == 'Charges' ? 'active_menu' : ''"
                            @click="active_menu('Charges'); menu_close()">Charges
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0);" :class="active == 'Biography' ? 'active_menu' : ''"
                            @click="active_menu('Biography'); menu_close()">Biography
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0);" :class="active == 'G-Details' ? 'active_menu' : ''"
                            @click="active_menu('G-Details'); menu_close()">Gallery
                          </a>
                        </li>
                        <!-- Bhilwara healthcare -->
                      </ul>
                    </div>
                  </nav>

                  <form @submit.prevent="Save_Information">
                    <!-- Basic Information -->
                    <div v-if="active == 'Details'" class="card ml-md-4">
                      <div class="card-body">
                        <div class="col-12 col-md-12">
                          <div class="d-flex form-group">
                            <div class="col-9 col-md-9 change-avatar">
                            </div>
                          </div>
                        </div>
                        <div class="row form-row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Hospital Name
                                <span class="text-danger">*</span></label>
                              <input type="text" disabled v-model="doctor_profile.hospital_name" class="form-control" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Email Id</label>
                              <input type="text" disabled v-model="doctor_profile.email_id" class="form-control" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Mobile Number</label>
                              <input type="text" disabled v-model="doctor_profile.mobile_no" class="form-control" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Council Registration Number</label>
                              <input type="text" v-model="doctor_profile.council_registration_number
                                " class="form-control" oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Hospital Type</label>
                              <v-select class="mr-2" required="" placeholder="Select Practice Type"
                                v-model="doctor_profile.practice_type" :options="practice_types">
                              </v-select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /Basic Information -->

                    <!-- Doctor Gallery -->
                    <div v-if="active == 'G-Details'" class="card ml-md-4">
                      <div class="card-body">
                        <div class="col-12 col-md-12">
                          <div class="d-md-flex flex-row flex-wrap justify-content-center">
                            <!-- Photo 1 -->
                            <div class="col-12 col-md-6 change-avatar">
                              <div class="profile-img">
                                <img
                                  v-bind:src="doctor_profile.photo_1 ? config.base_url_for_Image + doctor_profile.photo_1 : loadImg('gallary_photo.jpg')"
                                  alt="User Image" style="width:110px; height:110px;" />
                              </div>
                              <div class="upload-img">
                                <div class="change-photo-btn">
                                  <span><i class="fa fa-upload"></i> Upload</span>
                                  <input type="file" class="upload" accept="image/*"
                                    @change="onFileChange($event, 'doctor_photo_1')" />
                                </div>
                                <small class="form-text text-muted">Allowed JPG, GIF or PNG</small>
                                <small class="form-text text-muted">Max size of 2MB</small>
                              </div>
                            </div>
                            <!-- Photo 2 -->
                            <div class="col-12 col-md-6 change-avatar">
                              <div class="profile-img">
                                <img
                                  v-bind:src="doctor_profile.photo_2 ? config.base_url_for_Image + doctor_profile.photo_2 : loadImg('gallary_photo.jpg')"
                                  alt="User Image" style="width:110px; height:110px;" />
                              </div>
                              <div class="upload-img">
                                <div class="change-photo-btn">
                                  <span><i class="fa fa-upload"></i> Upload</span>
                                  <input type="file" class="upload" accept="image/*"
                                    @change="onFileChange($event, 'doctor_photo_2')" />
                                </div>
                                <small class="form-text text-muted">Allowed JPG, GIF or PNG</small>
                                <small class="form-text text-muted">Max size of 2MB</small>
                              </div>
                            </div>
                            <!-- Photo 3 -->
                            <div class="col-12 col-md-6 change-avatar">
                              <div class="profile-img">
                                <img
                                  v-bind:src="doctor_profile.photo_3 ? config.base_url_for_Image + doctor_profile.photo_3 : loadImg('gallary_photo.jpg')"
                                  alt="User Image" style="width:110px; height:110px;" />
                              </div>
                              <div class="upload-img">
                                <div class="change-photo-btn">
                                  <span><i class="fa fa-upload"></i> Upload</span>
                                  <input type="file" class="upload" accept="image/*"
                                    @change="onFileChange($event, 'doctor_photo_3')" />
                                </div>
                                <small class="form-text text-muted">Allowed JPG, GIF or PNG</small>
                                <small class="form-text text-muted">Max size of 2MB</small>
                              </div>
                            </div>
                            <!-- Photo 4 -->
                            <div class="col-12 col-md-6 change-avatar">
                              <div class="profile-img">
                                <img
                                  v-bind:src="doctor_profile.photo_4 ? config.base_url_for_Image + doctor_profile.photo_4 : loadImg('gallary_photo.jpg')"
                                  alt="User Image" style="width:110px; height:110px;" />
                              </div>
                              <div class="upload-img">
                                <div class="change-photo-btn">
                                  <span><i class="fa fa-upload"></i> Upload</span>
                                  <input type="file" class="upload" accept="image/*"
                                    @change="onFileChange($event, 'doctor_photo_4')" />
                                </div>
                                <small class="form-text text-muted">Allowed JPG, GIF or PNG</small>
                                <small class="form-text text-muted">Max size of 2MB</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /Doctor Gallery -->

                    <!-- Contact Details -->
                    <div v-if="active == 'C-Details'" class="card contact-card ml-md-4">
                      <div class="card-body">
                        <div class="row form-row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label>Address</label>
                              <input type="text" v-model="doctor_profile.address" class="form-control" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">State</label>
                              <v-select class="mr-2" name="state" required="" label="state" placeholder="Select State"
                                v-model="doctor_profile.state" :reduce="(option) => option.state" @input="
                                  get_cities();
                                doctor_profile.city = '';
                                " :options="states">
                              </v-select>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">City</label>
                              <v-select class="mr-2" name="city" required="" label="city" placeholder="Select City"
                                v-model="doctor_profile.city" :reduce="(option) => option.city" :options="cities">
                              </v-select>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">Pincode</label>
                              <input type="text" v-model="doctor_profile.pincode" class="form-control"
                                oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="form-group">
                              <label class="control-label">Suburb</label>
                              <input type="text" v-model="doctor_profile.suburb" class="form-control" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">Assistant Name
                              </label>
                              <input type="text" v-model="doctor_profile.name_of_assistant" class="form-control"
                                oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">Assistant Mobile No.</label>
                              <input type="text" v-model="doctor_profile.assistant_mobile" class="form-control"
                                maxlength="10" minlength="10" @keypress="onlyNumber"
                                oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">Assistant Whatsapp No.</label>
                              <input type="text" v-model="doctor_profile.assistant_whatsapp" class="form-control"
                                maxlength="10" minlength="10" @keypress="onlyNumber"
                                oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /Contact Details -->

                    <!-- Associated With Hospital -->
                    <div v-if="active == 'Association'" class="card ml-md-4">
                      <div class="card-body">
                        <div class="row align-items-center">
                          <div class="col-md-9">
                            <h4 class="card-title">Associated With Hospital</h4>
                          </div>
                          <div class="col-md-3 text-md-right">
                            <a href="#" data-toggle="modal" data-target="#addhospital" class="btn btn-primary btn-sm"
                              tabindex="0">Add Hospital</a>
                          </div>
                        </div>
                        <div v-for="(item, index) in associated_hospitals" :key="index">
                          <!-- {{ associated_hospitals }} -->
                          <div class="row form-row">
                            <div class="col-md-5 mt-2">
                              <div class="form-group">
                                <label>Hospital</label>
                                <v-select class="mr-2" name="name" required="" label="name_of_hospital"
                                  placeholder="Select Hospital" v-model="item.hospital" @input="set_city"
                                  :reduce="(option) => option.name" :options="filteredAssociatedLists[index]"
                                  :disabled="!isSaveClicked">
                                </v-select>
                              </div>
                            </div>
                            <div class="col-md-5">
                              <div class="form-group">
                                <label>City</label>
                                <input class="mr-2" type="text" v-if="item.hospital"
                                  style="border:1px solid #dfdfdf;width:100%; border-radius:3px; background-color:#DCDCDC; padding:6px; margin-top:2px;"
                                  disabled v-model="item.city" />
                              </div>
                            </div>
                            <div class="col-md-2" v-if="associated_hospitals.length !== 1">
                              <div class="form-group" style="margin-top: 43px; cursor: pointer">
                                <span class="circle" @click="remove_item('associated_hospitals', index)"
                                  v-if="item.hospital === '' || item.city === ''"><i class="fa fa-times" /></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="add-more">
                          <a href="javascript:void(0);" @click="add_Information('associated_hospitals')"
                            class="add-reg"><i class="fa fa-plus-circle"></i> Add More</a>
                        </div>
                      </div>
                    </div>
                    <!-- /Associated With Hospital  -->

                    <!-- Participation In Programs -->
                    <div v-if="active == 'kx'" class="card">
                      <div class="card-body">
                        <h4 class="card-title">Participation In Programs</h4>
                        <div class="row form-row" v-for="(item,
                          index) in participation_in_sahaj_programs" :key="index">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label v-if="index === 0">Program</label>
                              <!-- <input type="text" v-model="item.program" class="form-control"> -->
                              <v-select class="mr-2" name="name" required="" label="program_name"
                                placeholder="Select Program" v-model="item.program" :reduce="(option) => option.name"
                                :options="programs">
                              </v-select>
                            </div>
                          </div>
                          <div class="col-12 col-md-6 col-lg-6" v-if="participation_in_sahaj_programs.length !== 1">
                            <div class="form-group">
                              <div class="form-group" style="cursor: pointer" v-bind:style="index == 0
                                ? 'margin-top: 43px'
                                : 'margin-top: 12px'
                                ">
                                <span class="circle" @click="
                                  remove_item(
                                    'participation_in_sahaj_programs',
                                    index
                                  )
                                  "><i class="fa fa-times" /></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="add-more">
                          <a href="javascript:void(0);" @click="
                            add_Information('participation_in_sahaj_programs')
                            " class="add-reg"><i class="fa fa-plus-circle"></i> Add More</a>
                        </div>
                      </div>

                      <div class="card-body">
                        <h4 class="card-title">Upload Document</h4>
                        <div class="row">
                          <div class="col-sm-6">
                            <v-select class="mr-2" name="name" required="" label="program_name"
                              placeholder="Select Program" v-model="document" :options="document_options">
                            </v-select>
                          </div>
                          <div class="col-sm-6">
                            <input type="file" class="upload" accept="image/*"
                              @change="onFileChange($event, 'hospital_photo_1')" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /Participation In Programs -->

                    <!-- Surgery Charges -->
                    <div v-if="active == 'Charges'" class="card ml-md-4">
                      <div class="row">
                        <div class="col-6">
                          <div class="card-body">
                            <div>
                              <span>
                                <div class="form-group">
                                  <input type="checkbox" v-model="doctor_profile.show_charges_at_portal
                                    " id="showcharges" name="showcharges" value="Bike" />
                                  <label for="showcharges">
                                    Show Charges at Portal</label><br />
                                </div>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="col-6">
                          <div style="float:right;">
                            <a href="#" data-toggle="modal" data-target="#addhospital"
                              class="btn btn-primary btn-sm mr-3 mt-3" tabindex="0">Add Hospital</a>
                          </div>
                        </div>
                      </div>
                      <div class="card-body" style="margin-top:-30px;"
                        v-if="doctor_profile.healthcare_practitioner_category !== 'Physiotherapist'">
                        <h4 class="card-title ml-3">Surgery Charges</h4>
                        <div class="registrations-info" v-for="(item, index) in surgery_charges" :key="index">
                          <div class="col-12 col-md-10 col-lg-12">
                            <div class="row form-row">
                              <div class="col-12 col-md-6 col-lg-6">
                                <div class="form-group">
                                  <label v-if="index === 0">Surgery Type</label>
                                  <!-- <input type="text" v-model="item.surgery_type" class="form-control"> -->
                                  <v-select name="name" required="" label="name" placeholder="Select Surgery Type"
                                    v-model="item.surgery_type" :reduce="(option) => option.name"
                                    :options="surgery_types">
                                  </v-select>
                                </div>
                              </div>
                              <div class="col-12 col-md-5 col-lg-5">
                                <div class="form-group">
                                  <label v-if="index === 0">Hospital</label>
                                  <!-- <input type="text" v-model="item.hospital" class="form-control"> -->
                                  <v-select name="name" required="" label="name_of_hospital" placeholder="Select Hospital"
                                    v-model="item.hospital" :reduce="(option) => option.name" :options="ortho_hospitals">
                                  </v-select>
                                </div>
                              </div>
                              <div class="col-12 col-md-6 col-lg-3">
                                <div class="form-group">
                                  <label v-if="index === 0">Ward Type</label>
                                  <!-- <input type="text" v-model="item.ward_type" class="form-control"> -->
                                  <v-select name="name" required="" label="name" placeholder="Select Ward"
                                    v-model="item.ward_type" :reduce="(option) => option.name" :options="ward_types">
                                  </v-select>
                                </div>
                              </div>
                              <div class="col-12 col-md-6 col-lg-2">
                                <div class="form-group">
                                  <label v-if="index === 0">Charges</label>
                                  <input type="text" v-model="item.charges" class="form-control" maxlength="6"
                                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..?)\../g, '$1');" />
                                </div>
                              </div>
                              <div class="col-12 col-md-6 col-lg-1" v-if="surgery_charges.length !== 1">
                                <div class="form-group" style="margin-top: 43px; cursor: pointer">
                                  <span class="circle" @click="
                                    remove_item('surgery_charges', index)
                                    "><i class="fa fa-times" /></span>
                                </div>
                              </div>
                            </div>
                            <hr v-if="surgery_charges.length - 1 &&
                              surgery_charges.length > 1
                              " />
                          </div>
                        </div>
                        <div class="add-more">
                          <a href="javascript:void(0);" @click="add_Information('surgery_charges')" class="add-reg"><i
                              class="fa fa-plus-circle"></i> Add More</a>
                        </div>
                      </div>
                    </div>
                    <!-- /Surgery Charges -->

                    <!-- Modality Charges -->
                    <div v-if="active == 'Charges'" class="card ml-md-4 mt-2">
                      <div class="card-body">
                        <h4 class="card-title">Modality Charges</h4>
                        <div class="experience-info" v-for="(item, index) in modality_charges" :key="index">
                          <div class="row form-row experience-cont">
                            <div class="col-12 col-md-10 col-lg-12">
                              <div class="row form-row">
                                <div class="col-12 col-md-6 col-lg-4">
                                  <div class="form-group">
                                    <label v-if="index === 0">Modality</label>
                                    <!-- <input type="text" v-model="item.modality" class="form-control"> -->
                                    <v-select name="name" required="" label="name" placeholder="Select Modality"
                                      v-model="item.modality" :reduce="(option) => option.name" :options="modalities">
                                    </v-select>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-5">
                                  <div class="form-group">
                                    <label v-if="index === 0">Hospital</label>
                                    <!-- <input type="text" v-model="item.hospital" class="form-control"> -->
                                    <v-select name="name" required="" label="name_of_hospital"
                                      placeholder="Select Hospital" v-model="item.hospital"
                                      :reduce="(option) => option.name" :options="ortho_hospitals">
                                    </v-select>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-2">
                                  <div class="form-group">
                                    <label v-if="index === 0">Charges</label>
                                    <input type="text" v-model="item.charges" class="form-control" maxlength="4"
                                      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..?)\../g, '$1');" />
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-1" v-if="modality_charges.length !== 1">
                                  <div class="form-group" style="margin-top: 43px; cursor: pointer">
                                    <span class="circle" @click="
                                      remove_item('modality_charges', index)
                                      "><i class="fa fa-times" /></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="add-more">
                          <a href="javascript:void(0);" @click="add_Information('modality_charges')"
                            class="add-membership"><i class="fa fa-plus-circle"></i> Add More</a>
                        </div>
                      </div>
                    </div>
                    <!-- /Modality Charges -->

                    <!-- Experience -->
                    <div v-if="active == 'Education'" class="card ml-md-4">
                      <div class="card-body">
                        <h4 class="card-title">Experience</h4>
                        <div class="text-right" style="margin-top: -39px">
                          <a href="#" data-toggle="modal" data-target="#addhospital" class="btn btn-primary btn-sm mb-3"
                            tabindex="0">Add Hospital</a>
                        </div>
                        <div class="experience-info" v-for="(item, index) in experience_details" :key="index">
                          <div class="row form-row experience-cont">
                            <div class="col-12 col-md-10 col-lg-11">
                              <div class="row form-row">
                                <div class="col-12 col-md-6 col-lg-4">
                                  <div class="form-group">
                                    <label>Hospital Name</label>
                                    <!-- <input type="text" v-model="item.hospital_clinic" class="form-control"> -->
                                    <v-select class="mr-2" name="name" required="" label="name_of_hospital"
                                      placeholder="Select Hospital" v-model="item.hospital_clinic"
                                      :reduce="(option) => option.name" :options="filteredExperienceLists[index]">
                                    </v-select>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-2">
                                  <div class="form-group">
                                    <label>Year From</label>
                                    <input type="text" v-model="item.period_from" class="form-control" maxlength="4"
                                      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..?)\../g, '$1');" />
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-2">
                                  <div class="form-group">
                                    <label>Year To</label>
                                    <input type="text" v-model="item.period_to" class="form-control" maxlength="4"
                                      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..?)\../g, '$1');" />
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-3">
                                  <div class="form-group">
                                    <label>Designation</label>
                                    <input type="text" v-model="item.role" class="form-control" />
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-1" v-if="experience_details.length !== 1">
                                  <div class="form-group" style="margin-top: 43px; cursor: pointer">
                                    <span class="circle" @click="
                                      remove_item('experience_details', index)
                                      "><i class="fa fa-times" /></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="add-more">
                          <a href="javascript:void(0);" @click="add_Information('experience_details')"
                            class="add-experience"><i class="fa fa-plus-circle"></i> Add More</a>
                        </div>
                      </div>
                    </div>
                    <!-- /Experience -->

                    <!-- Awards -->
                    <div v-if="active == 'Education'" class="card m-3">
                      <div class="card-body">
                        <h4 class="card-title">Awards</h4>
                        <div class="awards-info" v-for="(item, index) in award_details" :key="index">
                          <div class="row form-row awards-cont">
                            <div class="col-12 col-md-4">
                              <div class="form-group">
                                <label>Award Name</label>
                                <input type="text" v-model="item.award_name" class="form-control" />
                              </div>
                            </div>
                            <div class="col-12 col-md-2">
                              <div class="form-group">
                                <label>Year</label>
                                <input type="text" v-model="item.year" class="form-control" maxlength="4"
                                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..?)\../g, '$1');" />
                              </div>
                            </div>
                            <div class="col-12 col-md-4">
                              <div class="form-group">
                                <label>Awarder</label>
                                <input type="text" v-model="item.awarder" class="form-control" />
                              </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-1" v-if="award_details.length !== 1">
                              <div class="form-group" style="margin-top: 43px; cursor: pointer">
                                <span class="circle" @click="remove_item('award_details', index)"><i
                                    class="fa fa-times" /></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="add-more">
                          <a href="javascript:void(0);" @click="add_Information('award_details')" class="add-award"><i
                              class="fa fa-plus-circle"></i> Add More</a>
                        </div>
                      </div>
                    </div>
                    <!-- /Awards -->

                    <div v-if="active == 'Biography'" class="card ml-md-4"> <!-- Added mt-3 for top margin -->
                      <div class="card-body">
                        <div class="form-group mb-0 testimonial">
                          <label>Biography</label>
                          <ckeditor :editor="editor" v-model="doctor_profile.about_me"></ckeditor>
                        </div>
                      </div>
                    </div>


                    <div class="submit-section submit-btn-bottom ml-md-4">
                      <!-- @click="Save_Information()" -->
                      <button type="submit" class="btn btn-primary submit-btn"
                        style="margin-top: 20px; text-align: left;">
                        Save Changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <layout-footer></layout-footer>
        </div>
      </div>
      <div class="modal fade custom-modal show" id="addhospital">
        <div class="modal-dialog modal-dialog-centered modal-lg doctor-profile">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Hospital</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="card">
                <div class="card-body">
                  <ul class="nav nav-tabs">
                    <li class="nav-item">
                      <a class="nav-link active" data-toggle="tab" href="#hospital-tab" style="color: #4b8565;">Hospital
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" data-toggle="tab" href="#gallery-tab" style="color: #378593;">Hospital
                        Gallery</a>
                    </li>
                  </ul>
                  <div class="tab-content">
                    <div class="tab-pane active" id="hospital-tab" role="tabpanel">
                      <div class="row form-row">
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>Type Of Hospital</label>
                            <v-select class="mr-2" name="sub_category_name" required="" label="sub_category_name"
                              placeholder="Select type of Hospital" v-model="new_hospital.type_of_hospital"
                              :reduce="(option) => option.sub_category_name" :options="hospital_types">
                            </v-select>
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>Name Of Hospital
                              <span class="text-danger">*</span></label>
                            <input v-model="new_hospital.name_of_hospital" type="text" class="form-control" value=""
                              oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');" />
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>No Of Beds</label>
                            <input v-model="new_hospital.no_of_beds" type="text" class="form-control" value=""
                              oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>Website</label>
                            <input v-model="new_hospital.website" type="text" class="form-control" value="" />
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>Tagline</label>
                            <input v-model="new_hospital.hospital_tagline" type="text" class="form-control" value="" />
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>Address</label>
                            <input v-model="new_hospital.address" type="text" class="form-control" value="" />
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>State</label>
                            <v-select class="mr-2" name="state" required="" label="state" placeholder="Select State"
                              v-model="new_hospital.state" :reduce="(option) => option.state"
                              @input="get_cities_for_addinghospital()" :options="states">
                            </v-select>
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>City <span class="text-danger">*</span></label>
                            <v-select class="mr-2" name="city" required="" label="city" placeholder="Select City"
                              v-model="new_hospital.city" :reduce="(option) => option.city" :options="cities">
                            </v-select>
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>Suburb</label>
                            <input v-model="new_hospital.suburb" type="text" class="form-control" value="" />
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>Pincode</label>
                            <input v-model="new_hospital.pincode" type="text" class="form-control" value=""
                              oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="tab-pane" id="gallery-tab" role="tabpanel">
                      <div class="container">
                        <div class="row">
                          <div class="col-12 col-md-6 mb-2">
                            <div class="change-avatar">
                              <div class="profile-img m-2">
                                <img v-bind:src="new_hospital.photo_1
                                  ? config.base_url_for_Image + new_hospital.photo_1
                                  : loadImg('doctor-thumb-02.jpg')" alt="User Image" />
                              </div>
                              <div class="upload-img">
                                <div class="change-photo-btn">
                                  <span><i class="fa fa-upload"></i> Upload</span>
                                  <input type="file" class="upload" accept="image/*"
                                    @change="onFileChange($event, 'hospital_photo_1')" />
                                </div>
                                <small class="form-text text-muted">Allowed JPG, GIF, or PNG. Max size of 2MB</small>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-6 mb-4">
                            <div class="change-avatar">
                              <div class="profile-img">
                                <img v-bind:src="new_hospital.photo_2
                                  ? config.base_url_for_Image + new_hospital.photo_2
                                  : loadImg('doctor-thumb-02.jpg')" alt="User Image" />
                              </div>
                              <div class="upload-img">
                                <div class="change-photo-btn">
                                  <span><i class="fa fa-upload"></i> Upload</span>
                                  <input type="file" class="upload" accept="image/*"
                                    @change="onFileChange($event, 'hospital_photo_2')" />
                                </div>
                                <small class="form-text text-muted">Allowed JPG, GIF, or PNG. Max size of 2MB</small>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-6 mb-4">
                            <div class="change-avatar">
                              <div class="profile-img">
                                <img v-bind:src="new_hospital.photo_3
                                  ? config.base_url_for_Image + new_hospital.photo_3
                                  : loadImg('doctor-thumb-02.jpg')" alt="User Image" />
                              </div>
                              <div class="upload-img">
                                <div class="change-photo-btn">
                                  <span><i class="fa fa-upload"></i> Upload</span>
                                  <input type="file" class="upload" accept="image/*"
                                    @change="onFileChange($event, 'hospital_photo_3')" />
                                </div>
                                <small class="form-text text-muted">Allowed JPG, GIF, or PNG. Max size of 2MB</small>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-6 mb-4">
                            <div class="change-avatar">
                              <div class="profile-img">
                                <img v-bind:src="new_hospital.photo_4
                                  ? config.base_url_for_Image + new_hospital.photo_4
                                  : loadImg('doctor-thumb-02.jpg')" alt="User Image" />
                              </div>
                              <div class="upload-img">
                                <div class="change-photo-btn">
                                  <span><i class="fa fa-upload"></i> Upload</span>
                                  <input type="file" class="upload" accept="image/*"
                                    @change="onFileChange($event, 'hospital_photo_4')" />
                                </div>
                                <small class="form-text text-muted">Allowed JPG, GIF, or PNG. Max size of 2MB</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="submit-section" style="text-align: left">
                  <button @click="add_hospital()" :disabled="disabled" class="btn btn-primary submit-btn  mb-2 ml-4"
                    data-dismiss="modal" aria-label="Close">
                    Add Hospital
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonApi from "../../../services/CommonApi";
import { mapState } from "vuex";
import config from "../../../services/CommonApi";
const images = require.context("@/assets/img/doctors");
import Datepicker from "vuejs-datepicker";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  data() {
    return {
      isSaveClicked: false,
      cityData: "",
      selectedQualifications: [],
      selectedAssociated: [],
      selectedExperience: [],
      document: null,
      document_options: ["a", "b", "c"],
      active: "Details",
      editor: ClassicEditor,
      format: "dd-MM-yyyy",
      state: {
        disabledDates: {
          from: new Date(),
        },
      },
      hospitalName: localStorage.getItem("hospitalID")
        ? JSON.parse(localStorage.getItem("hospitalID")).hospital
        : '',
      doctor_profile: {
        hospital_name: "",
        email_id: "",
        mobile_no: "",
        council_registration_number: "",
        healthcare_practitioner_category: "",
        practice_type: "",
        speciality: [],
        about_me: "",
        show_charges_at_portal: "",
        name_of_assistant: "",
        assistant_mobile: "",
        assistant_whatsapp: "",
        total_experience_in_years: "",
        address: "",
        city: "",
        state: "",
        suburb: "",
        pincode: "",
        photo_1: "",
        photo_2: "",
        photo_3: "",
        photo_4: "",
      },
      participation_in_sahaj_programs: [{ program: "" }],
      experience_details: [
        { hospital_clinic: "", role: "", period_from: "", period_to: "" },
      ],
      award_details: [{ award_name: "", year: "", awarder: "" }],
      modality_charges: [{ modality: "", hospital: "", charges: "" }],
      surgery_charges: [
        { surgery_type: "", hospital: "", ward_type: "", charges: "" },
      ],
      associated_hospitals: [{ hospital: "", city: "" }],
      states: [],
      cities: [],
      specialities: [],
      ortho_hospitals: [],
      all_cities: [],
      programs: [],
      qualifications: [],
      modalities: [],
      schedules: [],
      appointment_types: [],
      service_units: [],
      rooms: [],
      ward_types: [],
      surgery_types: [],
      practice_types: [],
      doctor_specialities: [],
      healthcare_practitioner_categories: [],
      showspinner: true,
      disabled: true,
      associated_hospitals_invalid: false,
      hospital_types: [],
      new_hospital: {
        type_of_hospital: "",
        name_of_hospital: "",
        no_of_beds: "",
        website: "",
        hospital_tagline: "",
        address: "",
        state: "",
        city: "",
        suburb: "",
        pincode: "",
        photo_1: "",
        photo_2: "",
        photo_3: "",
        photo_4: "",
      },
      config: config,
      user_image: localStorage.getItem("hospitalID")
        ? JSON.parse(localStorage.getItem("hospitalID")).image
        : null,
    };
  },
  components: { Datepicker, ckeditor: CKEditor.component },
  watch: {
    new_hospital: {
      handler() {
        this.validateForm();
      },
      deep: true,
    },
  },
  computed: {

    filteredAssociatedLists() {
      return this.associated_hospitals.map((item, index) => {
        const selectedInPrevious = this.associated_hospitals
          .slice(0, index)
          .map((d) => d.hospital);
        return this.ortho_hospitals.filter(
          (hospital) =>
            !selectedInPrevious.includes(hospital.name) &&
            !this.selectedAssociated.includes(hospital.name)
        );
      });
    },

    filteredExperienceLists() {
      return this.experience_details.map((item, index) => {
        const selectedInPrevious = this.experience_details
          .slice(0, index)
          .map((d) => d.hospital_clinic);
        return this.ortho_hospitals.filter(
          (hospital_clinic) =>
            !selectedInPrevious.includes(hospital_clinic.name) &&
            !this.selectedExperience.includes(hospital_clinic.name)
        );
      });
    },

    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
  },
  methods: {
    get_hospital_details() {
      // Prepare the data to be sent in the request
      const requestData = {
        hospital: this.hospitalName,
      };

      // Send the API request with the prepared data
      CommonApi.post_data("sahaj.hospital.get_hospital_doc", requestData)
        .then((res) => {
          this.showspinner = false;
          if (res) {
            this.doctor_profile.hospital_name = res.message.name;
            this.doctor_profile.email_id = res.message.email_id;
            this.doctor_profile.address = res.message.address;
            this.doctor_profile.mobile_no = res.message.mobile_no
            this.doctor_profile.state = res.message.state;
            this.doctor_profile.city = res.message.city;
            this.doctor_profile.pincode = res.message.pincode;
            this.doctor_profile.suburb = res.message.suburb;
            this.doctor_profile.photo_1 = res.message.photo_1;
            this.doctor_profile.photo_2 = res.message.photo_2;
            this.doctor_profile.photo_3 = res.message.photo_3;
            this.doctor_profile.photo_4 = res.message.photo_4;
            this.doctor_profile.about_me = res.message.about;
            this.surgery_charges = [];
            res.message.service_charges.map((item) =>
              this.surgery_charges.push({
                surgery_type: item.surgery_type,
                hospital: item.parent,
                ward_type: item.ward_type,
                charges: item.charges,
              })
            );

            // Process the response as needed
          }
        })
        .catch((error) => {
          // Handle errors if any
          console.error("Error fetching hospital details:", error);
        });
    },


    menu_close() {
      // Code to close the sidebar here
      var $wrapper = $(".main-wrapper");
      $("html").removeClass("menu-opened");
      $(".sidebar-overlay").removeClass("opened");
      $wrapper.removeClass("slide-nav");
    },

    /* Get Profile Image */
    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    isEducationDetailsEmpty(item) {
      return (
        !item.qualification ||
        !item.year_from ||
        !item.year_to ||
        !item.college
      );
    },

    active_menu(menu) {
      this.active = menu;
    },

    onChangeSpeciality(updateddata) {
      this.doctor_profile.speciality = [];
      updateddata.map((data) => {
        this.doctor_profile.speciality.push({
          speciality: data,
          name: data,
        });
      });
    },

    /* Change Profile Image */
    onFileChange(e, photo) {
      var files = e.target.files;
      if (!files.length) return;
      this.createImage(files[0], photo);
    },

    /* Create Profile Image */
    createImage(file, photo) {
      var reader = new FileReader();
      reader.onload = (e) => {
        if (photo === "main_image") {
          this.update_doctor_profile(file.name, e.target.result);
        } else if (photo === "doctor_photo_1") {
          this.doctor_gallery_photo_1_upload(file.name, e.target.result);
        } else if (photo === "doctor_photo_2") {
          this.doctor_gallery_photo_2_upload(file.name, e.target.result);
        } else if (photo === "doctor_photo_3") {
          this.doctor_gallery_photo_3_upload(file.name, e.target.result);
        } else if (photo === "doctor_photo_4") {
          this.doctor_gallery_photo_4_upload(file.name, e.target.result);
        } else if (photo === "hospital_photo_1") {
          this.hospital_gallery_photo_1_upload(file.name, e.target.result);
        } else if (photo === "hospital_photo_2") {
          this.hospital_gallery_photo_2_upload(file.name, e.target.result);
        } else if (photo === "hospital_photo_3") {
          this.hospital_gallery_photo_3_upload(file.name, e.target.result);
        } else if (photo === "hospital_photo_4") {
          this.hospital_gallery_photo_4_upload(file.name, e.target.result);
        }
      };
      reader.readAsDataURL(file);
    },

    /* Upload Image API */
    async update_doctor_profile(filename, upload_image) {
      this.$swal({
        text: "Updating Profile Photo...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.profile_photo_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          const retrievedString = localStorage.getItem("userInfo");
          const parsedObject = JSON.parse(retrievedString);
          parsedObject.image = res.data;
          const strigifiedForStorage = JSON.stringify(parsedObject);
          localStorage.setItem("userInfo", strigifiedForStorage);
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          }).then(() => {
            window.location.reload();
          });
        }
      });
    },

    /* Upload Doctor Gallary Image  1 API */
    async doctor_gallery_photo_1_upload(filename, upload_image) {
      this.$swal({
        text: "Updating Galley Photo...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        doctor: this.$store.state.user.user_id,
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.doctor_gallery_photo_1_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.get_hospital_details();
          this.$swal.close();
        }
      });
    },

    /* Upload Doctor Gallary Image  2 API */
    async doctor_gallery_photo_2_upload(filename, upload_image) {
      this.$swal({
        text: "Updating Galley Photo...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.doctor_gallery_photo_2_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.get_hospital_details();
          this.$swal.close();
        }
      });
    },

    /* Upload Doctor Gallary Image  3 API */
    async doctor_gallery_photo_3_upload(filename, upload_image) {
      this.$swal({
        text: "Updating Galley Photo...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        // doctor: this.$store.state.user.user_id,
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.doctor_gallery_photo_3_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.get_hospital_details();
          this.$swal.close();
        }
      });
    },

    /* Upload Doctor Gallary Image  4 API */
    async doctor_gallery_photo_4_upload(filename, upload_image) {
      this.$swal({
        text: "Updating Galley Photo...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        // doctor: this.$store.state.user.user_id,
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.doctor_gallery_photo_4_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.get_hospital_details();
          this.$swal.close();
        }
      });
    },

    /* Upload HospitaL Gallary Image 1 API */
    async hospital_gallery_photo_1_upload(filename, upload_image) {
      let data = {
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.hospital_gallery_photo_1_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.new_hospital.photo_1 = res.data.file_url;
        }
      });
    },

    /* Upload HospitaL Gallary Image 2 API */
    async hospital_gallery_photo_2_upload(filename, upload_image) {
      let data = {
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.hospital_gallery_photo_2_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.new_hospital.photo_2 = res.data.file_url;
        }
      });
    },

    /* Upload HospitaL Gallary Image 3 API */
    async hospital_gallery_photo_3_upload(filename, upload_image) {
      let data = {
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.hospital_gallery_photo_3_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.new_hospital.photo_3 = res.data.file_url;
        }
      });
    },

    /* Upload HospitaL Gallary Image 4 API */
    async hospital_gallery_photo_4_upload(filename, upload_image) {
      let data = {
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.hospital_gallery_photo_4_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.new_hospital.photo_4 = res.data.file_url;
        }
      });
    },

    validateForm() {
      if (
        this.new_hospital.name_of_hospital === "" ||
        this.new_hospital.city === ""
      ) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },

    /* Add Any Information */
    add_Information(type) {
      if (type === "participation_in_sahaj_programs") {
        this.participation_in_sahaj_programs.push({ program: "" });
      }
      else if (type === "experience_details") {
        const allFieldsFilled = this.experience_details.every(detail =>
          detail.hospital_clinic && detail.role && detail.period_from && detail.period_to
        );
        if (this.experience_details.length === 0 || allFieldsFilled) {
          this.experience_details.push({ hospital_clinic: "", role: "", period_from: "", period_to: "" });
        } else {
          this.$swal.fire({
            icon: "warning",
            title: "Warning",
            text: "Please select a value before adding another dropdown.",
            showConfirmButton: true,
          });
        }
      }
      else if (type === "award_details") {
        this.award_details.push({ award_name: "", year: "", awarder: "" });
      } else if (type === "modality_charges") {
        this.modality_charges.push({ modality: "", hospital: "", charges: "" });
      } else if (type === "surgery_charges") {
        this.surgery_charges.push({
          surgery_type: "",
          hospital: "",
          ward_type: "",
          charges: "",
        });
      } else if (type === "practitioner_speciality") {
        this.practitioner_speciality.push({ speciality: "" });

      } else if (type === "associated_hospitals") {
        this.isSaveClicked = true;
        const allFields = this.associated_hospitals.every(detail =>
          detail.hospital && detail.city
        );

        if (this.associated_hospitals.length === 0 || allFields) {
          this.associated_hospitals.push({ hospital: "", city: this.cityData });
        } else {
          this.$swal.fire({
            icon: "warning",
            title: "Warning",
            text: "Please select a value before adding another dropdown.",
            showConfirmButton: true,
          });
        }
      }
    },

    /* Remove Any Information */
    remove_item(type, id) {
      if (type === "participation_in_sahaj_programs") {
        this.participation_in_sahaj_programs.splice(id, 1);
      } else if (type === "experience_details") {
        this.experience_details.splice(id, 1);
      } else if (type === "award_details") {
        this.award_details.splice(id, 1);
      } else if (type === "modality_charges") {
        this.modality_charges.splice(id, 1);
      }
      else if (type === "surgery_charges") {
        this.surgery_charges.splice(id, 1);
      }
      else if (type === "practitioner_speciality") {
        this.practitioner_speciality.splice(id, 1);
      } else if (type === "associated_hospitals") {
        this.associated_hospitals.splice(id, 1);
      }
    },

    add_hospital() {
      if (!this.disabled) {
        this.$swal({
          text: "Adding Hospital...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var data = new FormData();
        data.append("data", JSON.stringify(this.new_hospital));
        CommonApi.post_data("sahaj.api.add_hospital", data).then((res) => {
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.get_hospital_list();
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
          (this.new_hospital.type_of_hospital = ""),
            (this.new_hospital.name_of_hospital = ""),
            (this.new_hospital.no_of_beds = ""),
            (this.new_hospital.website = ""),
            (this.new_hospital.state = ""),
            (this.new_hospital.city = ""),
            (this.new_hospital.suburb = ""),
            (this.new_hospital.pincode = "");
        });
      }
    },

    Validation_For_associated_hospitals() {
      this.associated_hospitals.some((data) => {
        if (
          data.city === "" ||
          data.hospital === "" ||
          data.city === null ||
          data.hospital === null
        ) {
          this.associated_hospitals_invalid = true;
        } else {
          this.associated_hospitals_invalid = false;
        }
      });
    },

    /* Save Doctor Informations */
    Save_Information() {

      this.showspinner = true;
      this.Validation_For_associated_hospitals();
      var data = new FormData();
      data.append("doctor_profile", JSON.stringify(this.doctor_profile));
      data.append(
        "experience_details",
        JSON.stringify(this.experience_details)
      );
      data.append(
        "participation_in_sahaj_programs",
        JSON.stringify(this.participation_in_sahaj_programs)
      );
      data.append("modality_charges", JSON.stringify(this.modality_charges));
      data.append("surgery_charges", JSON.stringify(this.surgery_charges));
      data.append(
        "practitioner_speciality",
        JSON.stringify(this.doctor_profile.speciality)
      );
      data.append("award_details", JSON.stringify(this.award_details));
      data.append(
        "associated_hospitals",
        JSON.stringify(this.associated_hospitals)
      );
      CommonApi.post_data("sahaj.api.update_doctor_profile_v2", data).then(
        (res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.get_hospital_details();
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
          this.isSaveClicked = true;
        }
      );
    },

    //Allow User to type number only
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },

    /* Convert Date to Required Format for API */
    convertDate(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
      }
    },

    /* Get Healthcare Sub Categories */
    async get_healthcare_sub_categories() {
      await CommonApi.get_data(
        "sahaj.finalapi.get_healthcare_sub_categories"
      ).then((res) => {
        if (res.status_code == 200) {
          this.hospital_types = res.data;
        }
      });
    },

    /* Get Healthcare Categories */
    async get_healthcare_categories() {
      await CommonApi.get_data(
        "sahaj.finalapi.get_healthcare_sub_categories"
      ).then((res) => {
        if (res.status_code == 200) {
          this.healthcare_practitioner_categories = res.data;
        }
      });
    },

    /* Get States */
    async get_states() {
      await CommonApi.get_data("sahaj.finalapi.get_states").then((res) => {
        this.states = res.message;
      });
    },

    /* Get States For Adding Hospital */
    async get_cities_for_addinghospital() {
      this.new_hospital.city = "";
      const params = new URLSearchParams();
      params.append("state", this.new_hospital.state);
      await CommonApi.get_data("sahaj.finalapi.get_city", params).then(
        (res) => {
          this.cities = res.message;
        }
      );
    },

    /* Get All Cities */
    async get_allcities() {
      await CommonApi.get_data("sahaj.finalapi.get_city").then((res) => {
        this.all_cities = res.message;
      });
    },

    /* Get Cities */
    async get_cities() {
      // this.doctor_profile.city = "";
      const params = new URLSearchParams();
      params.append("state", this.doctor_profile.state);
      await CommonApi.get_data("sahaj.finalapi.get_city", params).then(
        (res) => {
          this.cities = res.message;
        }
      );
    },

    /* Get Doctor Specialities */
    async get_core_speciality() {
      await CommonApi.get_data("sahaj.api.get_core_speciality").then((res) => {
        this.doctor_specialities = res.message;
      });
    },

    /* Get Practice types */
    async get_practice_type() {
      await CommonApi.get_data("sahaj.api.get_practice_type").then((res) => {
        this.practice_types = res.message;
      });
    },

    /* Get Cities */
    async get_speciality_list() {
      await CommonApi.get_data("sahaj.api.get_speciality_list").then((res) => {
        this.specialities = res.data;
      });
    },

    set_city(item) {
      const selectedHospital = this.associated_hospitals.find(
        (hospital) => hospital.hospital === item
      );
      if (selectedHospital) {
        const city = item.split('-')[1];
        selectedHospital.city = city;
      }
    },

    /* Get Ortho Hospitals */
    async get_hospital_list() {
      const params = new URLSearchParams();
      //   params.append("type_of_hospital","Ortho Hospital");
      await CommonApi.get_data("sahaj.api.get_hospital_list", params).then(
        (res) => {
          this.ortho_hospitals = res.data;
        }
      );
    },

    /* Get Programs */
    async get_sahaj_program() {
      await CommonApi.get_data("sahaj.api.get_sahaj_program").then((res) => {
        this.programs = res.data;
      });
    },

    /* Get Qualificatons */
    async get_qualificaton() {
      await CommonApi.get_data("sahaj.api.get_qualificaton").then((res) => {
        this.qualifications = res.data;
      });
    },

    /* Get Modalities */
    async get_modality() {
      await CommonApi.get_data("sahaj.api.get_modality").then((res) => {
        this.modalities = res.data;
      });
    },

    /* Get Schedules */
    async get_practitioner_schedule() {
      await CommonApi.get_data("sahaj.api.get_practitioner_schedule").then(
        (res) => {
          this.schedules = res.data;
        }
      );
    },

    /* Get Appointment Type */
    async get_appointment_type() {
      await CommonApi.get_data("sahaj.api.get_appointment_type").then((res) => {
        this.appointment_types = res.data;
      });
    },

    /* Get Appointment Type */
    async get_service_unit() {
      await CommonApi.get_data("sahaj.api.get_service_unit").then((res) => {
        this.service_units = res.data;
      });
    },

    /* Get Room Types */
    async get_room_type() {
      await CommonApi.get_data("sahaj.api.get_room_type").then((res) => {
        this.rooms = res.data;
      });
    },

    /* Get Ward Types */
    async get_ward_type() {
      await CommonApi.get_data("sahaj.api.get_ward_type").then((res) => {
        this.ward_types = res.data;
      });
    },


    /* Get Surgery Type */
    async get_surgery_type() {
      await CommonApi.get_data("sahaj.api.get_surgery_type").then((res) => {
        this.surgery_types = res.data;
      });
    },
  },
  mounted() {
    let user = localStorage.getItem("hospitalID");
    if (!user) {
      this.$router.push({ name: 'login' })
    }
    this.get_hospital_details();
    this.get_states();
    this.get_allcities();
    this.get_healthcare_categories();
    this.get_healthcare_sub_categories();
    this.get_core_speciality();
    this.get_practice_type();
    this.get_speciality_list();
    this.get_hospital_list();
    this.get_sahaj_program();
    this.get_modality();
    this.get_practitioner_schedule();
    this.get_appointment_type();
    this.get_service_unit();
    this.get_room_type();
    this.get_ward_type();
    this.get_surgery_type();
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%",
      });
    }
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fas fa-chevron-up",
          down: "fas fa-chevron-down",
          next: "fas fa-chevron-right",
          previous: "fas fa-chevron-left",
        },
      });
    }

    //sidebar open close
    var $wrapper = $(".main-wrapper");
    $(".main-nav a").on("click", function (e) {
      if (
        $(this)
          .parent()
          .hasClass("has-submenu")
      ) {
        e.preventDefault();
      }
      if (!$(this).hasClass("submenu")) {
        $("ul", $(this).parents("ul:first")).slideUp(350);
        $("a", $(this).parents("ul:first")).removeClass("submenu");
        $(this)
          .next("ul")
          .slideDown(350);
        $(this).addClass("submenu");
      } else if ($(this).hasClass("submenu")) {
        $(this).removeClass("submenu");
        $(this)
          .next("ul")
          .slideUp(350);
      }
    });
    $("body").append('<div class="sidebar-overlay"></div>');
    $(document).on("click", "#mobile_btn", function () {
      $wrapper.toggleClass("slide-nav");
      $(".sidebar-overlay").toggleClass("opened");
      $("html").addClass("menu-opened");
      $("#task_window").removeClass("opened");
      return false;
    });

    $(document).on("click", "#menu_close", function () {
      $("html").removeClass("menu-opened");
      $(".sidebar-overlay").removeClass("opened");
      $("main-wrapper").removeClass("slide-nav");
    });
    $(".main-nav ul li:not(.submenu) a").click(function () {
      $("html").removeClass("menu-opened");
      $(".sidebar-overlay").removeClass("opened");
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/kneexpert/hospital/Profile.vue